import type { IDriveContent } from 'src/@types/drive';
import { useDownloadDriveStore } from '../singleton';

export function useDownloadDriveContent(file: IDriveContent) {
  const { downloadContent, loading, progress } = useDownloadDriveStore((s) => ({
    downloadContent: s.downloadContent,
    loading: s.loadingMap[file._id] ?? false,
    progress: s.progressMap[file._id] ?? 0,
  }));

  const download = () => downloadContent(file);

  return {
    loadingProgress: { loading, progress },
    downloadContent: download,
  };
}
